import { render, staticRenderFns } from "./salesOrder-list.vue?vue&type=template&id=5592c2f9"
import script from "./salesOrder-list.vue?vue&type=script&lang=js"
export * from "./salesOrder-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports